import {Module} from 'vuex';
import store from '@/libs/core/store/store';
import {StoreName} from '@/libs/core/store/store-name';
import {CrudAction, CrudResponseAction} from '@/libs/core/crud/crud-action';
import {CrudGetter} from '@/libs/core/crud/crud-getter';
import {CrudEntity, CrudService} from '@/libs/core/crud/crud-service';
import {createCrudStoreState, CrudStoreState} from '@/libs/core/crud/crud-store-state';
import {createCrudActions} from '@/libs/core/crud/crud-store-actions';
import {crudMutations} from '@/libs/core/crud/crud-store-mutations';
import {crudGetters} from '@/libs/core/crud/crud-store-getters';
import {createStoreDispatcher, createStoreGetter} from '@/libs/core/crud/store-accessors';

export interface RegisteredCrudStore<T> {
    dispatch: (action: CrudAction | CrudResponseAction, payload: any) => void;
    useGetter: (getter: CrudGetter, ...params: any[]) => any;
    getActionName: (action: CrudAction | CrudResponseAction) => string;
    subscribe: (action: CrudAction | CrudResponseAction, callback: (payload: any) => void, key?: string) => () => void;
}

export function registerCrudStore<T extends CrudEntity, TDetail extends CrudEntity>(storeName: StoreName, crudService: CrudService<T, TDetail>): RegisteredCrudStore<T> {
    const crudStoreModule: Module<CrudStoreState<any, any>, unknown> = {
        namespaced: true,
        state: createCrudStoreState<T, TDetail>(),
        actions: createCrudActions(crudService),
        mutations: crudMutations,
        getters: crudGetters,
    };
    store.registerModule(storeName, crudStoreModule);

    return {
        dispatch: createStoreDispatcher(storeName),
        useGetter: createStoreGetter(storeName),
        getActionName: action => `${storeName}/${action}`,
        subscribe: (action, callback, key) => store.subscribe(mutation => {
            if (mutation.type === `${storeName}/${action}` && (!key || mutation.payload.key === key)) {
                callback(mutation.payload);
            }
        })
    };
}
